/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Content, Overlay, Wrapper } from './styles';
import { dashboardFiltersEnum } from '../../enums';
import { getBigNumbers, getPeriodList } from '../../../../redux/dashboard-completed';
import { getDeliveryStatusDeliveriesList } from '../../../../redux/delivery-status';
import { getNfListLocation } from '../../../../redux/dashboard-real-time';
import { changeFilters } from '../../../../redux/dashboard-filters';
import CarrierList from './CarrierList';
import RangeDate from './RangeDate';
import ViewType from './ViewType';

const DashboardFilters = ({ dispatch, currentTab, deliveryStatusActiveTab }) => {
  const [activeFilter, setActiveFilter] = useState(null);
  const [viewTypeValue, setViewTypeValue] = useState(null);
  const [rangePeriodValue, setRangePeriodValue] = useState(null);
  const [carrierListValue, setCarrierListValue] = useState(null);

  const toggleFilter = filter => {
    setActiveFilter(activeFilter === filter ? null : filter);
  };

  const getDashboardItems = () => {
    if (currentTab === '/u/dashboard/historico') {
      dispatch(getBigNumbers());
      dispatch(getPeriodList());
    } else {
      dispatch(getDeliveryStatusDeliveriesList(false, 'realTime', false))
      .then(data => dispatch(getNfListLocation(deliveryStatusActiveTab, data)));
    }
  }

  const applyViewTypeFilter = ({ byDate, displayValue })  => {
    setViewTypeValue(displayValue);
    dispatch(changeFilters({ byDate }));
    getDashboardItems();

    toggleFilter(dashboardFiltersEnum.VIEW_TYPE);
  };

  const applyRangePeriodFilter = ({ initialPeriod, finalPeriod, displayValue }) => {
    setRangePeriodValue(displayValue);
    dispatch(changeFilters({ initialPeriod, finalPeriod }));
    getDashboardItems();

    toggleFilter(dashboardFiltersEnum.RANGE_PERIOD);
  };

  const applyCarrierListFilter = ({carrierList, displayValue}) => {
    setCarrierListValue(displayValue);
    dispatch(changeFilters({ carrierList }));
    getDashboardItems();

    toggleFilter(dashboardFiltersEnum.CARRIER_LIST);
  };

  return (
    <Wrapper>
      <Content>
        {activeFilter && (
          <Overlay onClick={() => toggleFilter(activeFilter)} />
        )}
        <ViewType
          onClick={() => toggleFilter(dashboardFiltersEnum.VIEW_TYPE)}
          isOpen={activeFilter === dashboardFiltersEnum.VIEW_TYPE}
          onApply={applyViewTypeFilter}
          value={viewTypeValue}
        />
        <RangeDate
          onClick={() => toggleFilter(dashboardFiltersEnum.RANGE_PERIOD)}
          isOpen={activeFilter === dashboardFiltersEnum.RANGE_PERIOD}
          onApply={applyRangePeriodFilter}
          value={rangePeriodValue}
        />
        <CarrierList
          onClick={() => toggleFilter(dashboardFiltersEnum.CARRIER_LIST)}
          isOpen={activeFilter === dashboardFiltersEnum.CARRIER_LIST}
          onApply={applyCarrierListFilter}
          value={carrierListValue}
        />
      </Content>
    </Wrapper>
  );
};

function mapStateToProps(state) {
  return {
    deliveryStatusActiveTab: state.deliveryStatus.performanceStatusSelected,
  };
}

export default connect(mapStateToProps)(DashboardFilters);
